import { render, staticRenderFns } from "./userHouse-info.vue?vue&type=template&id=227399a4&scoped=true&"
import script from "./userHouse-info.vue?vue&type=script&lang=js&"
export * from "./userHouse-info.vue?vue&type=script&lang=js&"
import style0 from "./userHouse-info.vue?vue&type=style&index=0&id=227399a4&scoped=true&lang=css&"
import style1 from "./userHouse-info.vue?vue&type=style&index=1&id=227399a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227399a4",
  null
  
)

export default component.exports